
  import {
    defineComponent,
    ref,
    onMounted,
    computed,
    onBeforeUnmount,
  } from 'vue';
  import { useRouter } from 'vue-router';
  import Datatable from '@/components/kt-datatable/KTDatatable.vue';
  import { setCurrentPageBreadcrumbs } from '@/core/helpers/breadcrumb';
  import { useI18n } from 'vue-i18n/index';
  import { useStore } from 'vuex';
  import { Actions } from '@/store/enums/StoreEnums';
  import { useAbility } from '@casl/vue';
  import Swal from 'sweetalert2/dist/sweetalert2.js';

  export default defineComponent({
    name: 'package-discount-listing',
    components: {
      Datatable,
    },
    async setup() {
      const { t, te } = useI18n();
      const store = useStore();
      const router = useRouter();
      const { can } = useAbility();

      const translate = (text) => {
        if (te(text)) {
          return t(text);
        } else {
          return text;
        }
      };

      const searchItems = async () => {
        // await store.dispatch(Actions.UPDATE_SETTINGS_CLASS_LEVEL_FILTER, {
        //   name: inputText,
        // });
        // await store.dispatch(Actions.GET_PACKAGE_DISCOUNTS);
      };

      onMounted(async () => {
        setCurrentPageBreadcrumbs(translate('Package Discount Listing'), [
          translate('settings'),
        ]);

        onBeforeUnmount(() => {
          store.dispatch(Actions.RESET_PACKAGE_DISCOUNT_STORE);
        });
        loading.value = true;
        await store.dispatch(Actions.GET_PACKAGE_DISCOUNTS);
        loading.value = false;
      });
      const loading = ref(false);
      const tableHeader = ref([
        {
          name: translate('Name'),
          key: 'name',
          sortable: true,
        },
        {
          name: translate('Class Category'),
          key: 'classCategory',
          sortable: true,
        },
        {
          name: translate('Discount Amount'),
          key: 'discountAmount',
          sortable: true,
        },
        {
          name: translate('Number of Lessons'),
          key: 'numberOfLessons',
          sortable: true,
        },
        {
          name: translate('Actions'),
          key: 'actions',
        },
      ]);

      const deletePackageDiscount = async (packageDiscount) => {
        const result = await Swal.fire({
          title: translate('areYouSureQ'),
          icon: 'warning',
          showCancelButton: true,
          buttonsStyling: false,
          confirmButtonText: translate('confirm'),
          cancelButtonText: translate('cancel'),
          customClass: {
            confirmButton: 'btn fw-bold btn-warning',
            cancelButton: 'btn btn-light',
          },
        });

        if (result.value) {
          loading.value = true;
          await store.dispatch(
            Actions.DELETE_PACKAGE_DISCOUNT,
            packageDiscount.id
          );
          await store.dispatch(Actions.GET_PACKAGE_DISCOUNTS);
          loading.value = false;
          const [errorName] = Object.keys(store.getters.getErrors);
          const error = store.getters.getErrors[errorName];
          if (error) {
            Swal.fire({
              text: translate(error[0]),
              icon: 'error',
              buttonsStyling: false,
              confirmButtonText: translate('tryAgainExcl'),
              customClass: {
                confirmButton: 'btn fw-bold btn-light-danger',
              },
            });
          }
        }
      };

      const editPackageDiscount = (id) => {
        router.push({ name: 'package-discount-editing', params: { id } });
      };

      const goTo = (pageName) => {
        router.push({ name: pageName });
      };

      const pageChanged = async (val) => {
        loading.value = true;
        await store.dispatch(Actions.UPDATE_PACKAGE_DISCOUNT_CURRENT_PAGE, val);
        await store.dispatch(Actions.GET_PACKAGE_DISCOUNTS);
        loading.value = false;
      };

      return {
        tableData: computed(() => store.getters.packageDiscountList),
        tableHeader,
        inputText: '',
        searchItems,
        deletePackageDiscount,
        translate,
        totalItems: computed(() => store.getters.packageDiscountListCount),
        pageChanged,
        goTo,
        editPackageDiscount,
        loading,
        can,
      };
    },
  });
